// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getStorage} from 'firebase/storage';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCpDFju0fkkeOFDdB8LDA_Es1Roz7f5YAk",
  authDomain: "spslandpromoters-theni.firebaseapp.com",
  projectId: "spslandpromoters-theni",
  storageBucket: "spslandpromoters-theni.appspot.com",
  messagingSenderId: "118638953486",
  appId: "1:118638953486:web:19b223c02262e1bc3f285f",
  measurementId: "G-G5KYNKD6SN"
};

// const firebaseConfig = {
//   apiKey:process.env.REACT_APP_API_KEY,
//   authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_APP_ID ,
//   measurementId: process.env.REACT_APP_MEASUREMENT_ID
// };

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
const analytics = getAnalytics(app);
